import Vue from 'vue';
import VueIntercom from 'vue-intercom';

if (process.env.RAILS_ENV === 'production' || process.env.RAILS_ENV === 'staging') {
  Vue.use(VueIntercom, { appId: process.env.SHAKAPACKER_PUBLIC_INTERCOM_APP_ID });
}
